export default __webpack_public_path__ + "static/media/settings.9e5770dd.svg";